/* eslint react/prop-types: "off" */
import React, { createContext, useContext, useReducer, useEffect } from 'react';
import firebase from 'firebase';


// data layer
export const StateContext = createContext();

// provider
export const StateProvider = ({ reducer, initialState, children }) => {

  const reducerHook = useReducer(reducer, initialState);
  const dispatch = reducerHook[1];
  const usersRef = firebase.database().ref('/users');

  useEffect(() => {
    usersRef.on('value', (data) => {
      console.log('::::::::: ', data, dispatch);
      dispatch({ type: 'TOGGLE_THEME' });
      data.forEach((item) => {
        console.log(`:::: ${item.key} ${item.val().name}`);
      });
    });
    // console.log(':::: useEffect', theme);
    return () => {
      usersRef.off('value');
      console.log(':::: useEffect cancel', 'dispatch');
    };
  }, []);

  return (
    <StateContext.Provider value={reducerHook}>
      { children }
    </StateContext.Provider>
  );
};


export const useStateValue = () => useContext(StateContext);



// WEBPACK FOOTER //
// ./src/components/stateProvider/stateProvider.js